/* RESPONSIBLE TEAM: team-proactive-support */
import { attr } from '@ember-data/model';
import MF from 'ember-data-model-fragments';

export default MF.Fragment.extend({
  ios: attr('string'),
  android: attr('string'),
});
